<footer class="mt-2 cursor-pointer font-semibold text-center" (click)="openIntercom()">
  <div i18n *ngIf="showCannotFindTrailer">Can't find it?</div>
  <div i18n *ngIf="showContactSupport">Contact Support</div>
</footer>
